import React from 'react';

interface Props {
  searchTerm: string;
  setSearchTerm: (value: string, any) => void;
}

const SearchClearButton = ({ searchTerm, setSearchTerm }: Props) => {
  if (!searchTerm) {
    return <></>;
  }

  return (
    <button onClick={() => setSearchTerm('', { shouldClearFilters: false })} className="search-header__clear-button"></button>
  );
};

export default SearchClearButton;
